import { IUserModel } from '@Shared/models';
import {
  IBackupCodeRequest,
  ICreateUsersRequest,
  IDisableMFAResponse,
  IRegenerateBackupCodeResponse,
  IResendInviteToUsersRequest,
  ISetupMFARequest,
  ISetupMFAResponse
} from '@Shared/types';

import { Api as apiService } from '../api';

export abstract class UsersApiService {
  static getAll(): Promise<IUserModel[]> {
    return apiService.responseToJSONAndToastError(apiService.get('/api/web/users'));
  }

  static getUsersData(user_id: string) {
    return apiService.responseToJSONAndToastError(apiService.get(`/api/web/users/info/${user_id}`));
  }

  static getCurrentUser(includes: (keyof IUserModel)[]): Promise<IUserModel> {
    return apiService.responseToJSONAndToastError(apiService.get('/api/web/whoami', includes));
  }

  static resendMFACode(): Promise<Response> {
    return apiService.post('/api/users/resend_mfa_code');
  }

  static backupCode(payload: IBackupCodeRequest): Promise<Response> {
    return apiService.responseToJSONAndToastError(apiService.post('/api/users/backup_code', payload));
  }

  static setupMFA(payload: ISetupMFARequest): Promise<ISetupMFAResponse> {
    return apiService.responseToJSONAndToastError(apiService.put('/api/users/mfa', payload));
  }

  static regenerateBackupCode(): Promise<IRegenerateBackupCodeResponse> {
    return apiService.responseToJSONAndToastError(apiService.post('/api/users/regenerate_backup_code'));
  }

  static disableMFA(): Promise<IDisableMFAResponse> {
    return apiService.responseToJSONAndToastError(apiService.post('/api/users/disable_mfa'));
  }

  static createUsers(body: ICreateUsersRequest): Promise<any> {
    return apiService.responseToJSONAndToastError(apiService.post(`/api/web/users`, body));
  }

  static update(user_id: string, body: Partial<IUserModel>): Promise<any> {
    return apiService.responseToJSONAndToastError(apiService.put(`/api/web/users/${user_id}`, body));
  }

  static bulkResendInvite(payload: IResendInviteToUsersRequest): Promise<Response> {
    return apiService.responseToJSONAndToastError(apiService.post('/api/web/users/bulk/invite/resend', payload));
  }

  static cancelBulkInvite(userIds: string[]) {
    return apiService.post('/api/web/users/bulk/invite/cancel', { user_profile_ids: userIds });
  }
}
